import {request} from './request'

//微信获取code的链接
export function getQr(data){
    return request({
        url:"/get_qr",
        method:'post',
        data
    })
}

// 通过code获取openid
export function getOpenId(data){
    return request({
        url:"/get_openid",
        method:'post',
        data
    })
}

// 微信登录
export function login(data){
    return request({
        url:"/wx/login",
        method:'post',
        data
    })
}

// 刷新微信的token
export function refreshToken(data){
    return request({
        url:"/refresh_token",
        method:'post',
        data
    })
}

// 获取用户信息
export function wxUserInfo(){
    return request({
        url:"/wx-user/getInfo",
        method:'post',
    })
}

// 退出登录
export function outLogin(){
    return request({
        url:"/logout",
        method:'post',
    })
}